import { Configuration, IdentificationReliabilityConfig, KentIdentyumControllerApi } from 'kent-identyum-service-api';
import Cookies from 'universal-cookie/es6';
import { AppSettings } from '../common/app-settings';

export const KentIdentyumControllerClient = (): KentIdentyumControllerApi => {
    const cookies = new Cookies();
    const token = cookies.get(AppSettings.ACCESS_TOKEN_OBJECT_COOKIE);
    const configuration: Configuration = new Configuration({ accessToken: token.accessToken, basePath: process.env.REACT_APP_IDENTYUM_SERVICE });
    return new KentIdentyumControllerApi(configuration);
};

export const getIdentificationReliabilityConfig = async (): Promise<IdentificationReliabilityConfig> => {
    return KentIdentyumControllerClient()
        .getConfig()
        .then((response) => response.data)
        .catch((error) => {
            throw error;
        });
};

export const putIdentificationReliabilityConfig = async (
    identificationReliabilityConfig: IdentificationReliabilityConfig,
): Promise<IdentificationReliabilityConfig> => {
    return KentIdentyumControllerClient()
        .updateConfig(identificationReliabilityConfig)
        .then((response) => response.data)
        .catch((error) => {
            throw error;
        });
};
